import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './modules/home/pages/login/login.component';
import { SignupComponent } from './modules/home/pages/signup/signup.component';
import { ForgotComponent } from './modules/home/pages/forgot/forgot.component';
import { UpgradeComponent } from './modules/account/upgrade/upgrade.component';
import { AuthGuard } from './core/authentication/auth.guard';
import { CheckoutComponent } from './modules/home/pages/checkout/checkout.component';
import { PackComponent } from './modules/account/pack/pack.component';
import { AgradecimientoComponent } from './modules/home/pages/agradecimiento/agradecimiento.component';
import { PaymentmethodComponent } from './modules/account/paymentmethod/paymentmethod.component';
import { AfterLoginComponent } from './modules/home/pages/afterlogin/afterlogin.component';
import { ThankYouPageComponent } from './modules/home/pages/thank-you-page/thank-you-page.component';
import { WorkspaceSeetingsComponent } from './modules/workspace/workspace-seetings/workspace-seetings.component';
import { ProfileSettingsComponent } from './modules/profile/profile-settings/profile-settings.component';
import { CallCenterComponent } from './modules/home/pages/call-center/call-center.component';
import { PlanesMembresiaComponent } from './modules/home/pages/planes-membresia/planes-membresia.component';
import { DirectorysComponent } from './modules/access/directorys/directorys.component';
import { ListActivitesComponent } from './modules/access/list-activites/list-activites.component';
import { SubMenuComponent } from './shared/components/sub-menu/sub-menu.component';
import { Graph } from './test';
import { PlanBillingComponent } from './modules/home/pages/plan-billing/plan-billing.component';

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'signup', component: SignupComponent },
  { path: 'forgot', component: ForgotComponent },
  { path: 'upgrade', component: UpgradeComponent, canActivate: [AuthGuard] },
  { path: 'checkout', component: CheckoutComponent },
  { path: 'pack', component: PackComponent, canActivate: [AuthGuard] },
  { path: 'agradecimiento/:mensaje/:plan', component: AgradecimientoComponent, canActivate: [AuthGuard] },
  { path: 'paymentmethod', component: PaymentmethodComponent, canActivate: [AuthGuard] },
  {
    path: 'afterlogin', component: AfterLoginComponent, canActivate: [AuthGuard],
    children: [{
      path: 'directory',
      component: DirectorysComponent, 
      canActivate: [AuthGuard]
      
    },
    {
      path: 'Portafolios/:id',
      component: ListActivitesComponent,
      canActivate: [AuthGuard]
    },
    {
      path: 'list-activites/:id',
      component: ListActivitesComponent,
      canActivate: [AuthGuard]
    },
    {
      path: 'build/:id',
      component: SubMenuComponent,
      canActivate: [AuthGuard]
    },
    ]
  },
  { path: 'Thank-You', component: ThankYouPageComponent, canActivate: [AuthGuard] },
  { path: 'workspace/settings', component: WorkspaceSeetingsComponent, canActivate: [AuthGuard] },
  { path: 'profile-settings', component: ProfileSettingsComponent, canActivate: [AuthGuard] },
  { path: 'call-center', component: CallCenterComponent, canActivate: [AuthGuard] },
  { path: 'planes-membresia', component: PlanesMembresiaComponent },
  { path: 'plan-billing', component: PlanBillingComponent },
  { path: 'Graph', component: Graph }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
